import type { WidgetMode } from '../../common/@types'
import { API_URL } from '../../constants/environment'
import { Api } from '../../utils/api'
import { getLsAuthToken, setLsAuthToken } from '../../utils/localStorage'
import type { Session } from './@types'

const api = new Api(API_URL, 'customers/sessions')

export const createSession = async (app_id: string, widget_mode: WidgetMode) => {
  const session = (
    await api.post<Session>({
      headers: {
        Authorization: `Bearer ${getLsAuthToken(app_id)}`,
        'Ccn-App': widget_mode,
      },
      body: {
        data: {
          type: 'customer_session',
          attributes: {
            app_id,
          },
        },
      },
    })
  ).data
  setLsAuthToken(app_id, session.attributes.auth_token)

  return session
}
